import React, { useEffect } from 'react';
import { initPixel } from './lib/pixel';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Modules } from './components/Modules';
import { ForWho } from './components/ForWho';
import { TriadAndBonuses } from './components/TriadAndBonuses';
import { Testimonials } from './components/Testimonials';
import { Offer } from './components/Offer';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initPixel();
  }, []);
  return <div className="min-h-screen bg-brand-cream text-brand-ink font-sans selection:bg-brand-gold selection:text-brand-ink" data-id="element-0">
      <Hero data-id="element-1" />
      <Problem data-id="element-2" />
      <Modules data-id="element-3" />
      <ForWho data-id="element-4" />
      <TriadAndBonuses data-id="element-5" />
      <Testimonials data-id="element-6" />
      <Offer data-id="element-7" />
      <FAQ data-id="element-8" />
      <Footer data-id="element-9" />
    </div>;
}